import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/Store';
import Spinner from './views/spinner/Spinner';
import './_mockApis';
import './utils/i18n';
import { FontSizeProvider } from './context/FontContext/FontSizeContext'; // ✅ Tambahkan ini

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <FontSizeProvider> {/* ✅ Bungkus App di sini */}
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>
    </FontSizeProvider>
  </Provider>
);
